import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  getSplatUserType,
  isRetailUser,
} from "@sunrun/sales-experience-shared";
import { useHybridToken } from "providers/Auth";
import { useUserProfile } from "providers/UserProfile";
import { getNewPath } from "adapters/common";

const localStorageKey = "previousHybridToken";

const ChannelSelectionDirector = () => {
  const navigate = useNavigate();
  const { userProfile: userProfileData } = useUserProfile();
  const userType =
    JSON.stringify(userProfileData) !== "{}"
      ? getSplatUserType(userProfileData)
      : "";
  const isRetail = userType && isRetailUser(userType);
  const hybridToken = useHybridToken();

  useEffect(() => {
    const previousHybridToken = localStorage.getItem(localStorageKey);

    if (hybridToken !== previousHybridToken && isRetail && hybridToken !== "") {
      localStorage.setItem(localStorageKey, hybridToken);
      navigate(getNewPath("/dashboard"));
    }
  }, [hybridToken, userProfileData, navigate, isRetail]);

  return null;
};

export { ChannelSelectionDirector };
